// Deletion is an intentional horizontal drag beyond the nail, not a small
// positional adjustment, resize, pinch, or swipe on the empty canvas.
export function layerDeleteSide(start, point, bounds) {
  if (!start || !point || !bounds) return null;
  const dx = point.x - start.x, dy = point.y - start.y;
  if (Math.abs(dx) < 64 || Math.abs(dx) < Math.abs(dy) * 1.35) return null;
  const margin = Math.max(28, Math.min(48, bounds.width * .16));
  if (dx < 0 && point.x < bounds.left - margin) return 'left';
  if (dx > 0 && point.x > bounds.right + margin) return 'right';
  return null;
}
